import React from "react";
import { Wrapper } from "../components/Wrapper/Wrapper";
import HeadTag from "../components/HeadTag/HeadTag";
import { LangContext } from "../context/lang/LangContext";
import { english } from "../context/lang/langs/englishMessages";
import { spanish } from "../context/lang/langs/spanishMessages";
import AnimatedElement from "../components/AnimatedElement/AnimatedElement";
import Customers from "../components/Sections/Customers/Customers";

const AboutUs = React.lazy(
  () => import("../components/Sections/AboutUs/AboutUs"),
);
const Benefits = React.lazy(
  () => import("../components/Sections/Benefits/Benefits"),
);
const Metrics = React.lazy(
  () => import("../components/Sections/Metrics/Metrics"),
);
const Users = React.lazy(() => import("../components/Sections/Users/Users"));
const Services = React.lazy(
  () => import("../components/Sections/Services/Services"),
);
const Languages = React.lazy(
  () => import("../components/Sections/Languages/Languages"),
);
const HowItWorks = React.lazy(
  () => import("../components/Sections/HowItWorks/HowItWorks"),
);
const Architectures = React.lazy(
  () => import("../components/Sections/Architectures/Architectures"),
);

export const Index = () => {
  return (
    <>
      <Wrapper>
        <div className="Sections">
          <AnimatedElement>
            <AboutUs />
          </AnimatedElement>
          <AnimatedElement>
            <Benefits />
          </AnimatedElement>
          <AnimatedElement>
            <Metrics />
          </AnimatedElement>
          <AnimatedElement>
            <Users />
          </AnimatedElement>
          <AnimatedElement>
            <Services />
          </AnimatedElement>
          <AnimatedElement>
            <Languages />
          </AnimatedElement>
          <AnimatedElement>
            <HowItWorks />
          </AnimatedElement>
          <AnimatedElement>
            <Architectures />
          </AnimatedElement>
          <AnimatedElement>
            <Customers />
          </AnimatedElement>
        </div>
      </Wrapper>
    </>
  );
};

const isBrowser = typeof window !== "undefined";

const langInit = () => {
  if (!isBrowser) return english;

  switch (true) {
    case window.navigator.language.includes("en"):
      return english;
    case window.navigator.language.includes("es"):
      return spanish;
    default:
      return english;
  }
};

const IndexPage = () => {
  return (
    <>
      {isBrowser && (
        <LangContext.Provider value={{ messages: langInit() }}>
          <Index />
        </LangContext.Provider>
      )}
    </>
  );
};

export function Head() {
  return (
    <>
      <html lang="en" />
      <meta httpEquiv="content-language" content="en-us"></meta>
      <HeadTag />
    </>
  );
}

export default IndexPage;
